var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1532_3051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1532_3051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4935 38.7713C33.9465 35.8427 23.9998 34.0049 23.9998 34.0049C23.9998 34.0049 14.0531 35.8427 12.5061 38.7713C11.3625 42.8355 10.406 47.9995 10.406 47.9995H23.9998H37.5936C37.5936 47.9995 36.9474 42.4625 35.4935 38.7713Z",
    fill: "#F1C9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34.0049C24 34.0049 33.9467 35.8427 35.4937 38.7713C36.9479 42.4625 37.5938 47.9995 37.5938 47.9995H24V34.0049Z",
    fill: "#E4B692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7077 28.0515H21.2921V37.1149H26.7077V28.0515Z",
    fill: "#F1C9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7078 28.0515H24V37.1149H26.7078V28.0515Z",
    fill: "#E4B692"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.2921 32.2513C21.7792 33.6495 23.7446 34.4509 25.1882 34.4509C25.7104 34.4509 26.2184 34.3633 26.7077 34.2032V28.0515H21.2921V32.2513Z",
    fill: "#DDAC8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9625 22.332C30.9625 16.671 27.8452 13.4519 23.9998 13.4519C20.1544 13.4519 17.0371 16.671 17.0371 22.332C17.0371 29.9465 20.1544 32.5827 23.9998 32.5827C27.8448 32.5827 30.9625 29.6292 30.9625 22.332Z",
    fill: "#F1C9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9027 26.258C28.6405 26.1261 27.7884 24.766 28.0022 23.2223C28.2134 21.6772 29.4087 20.5301 30.6716 20.6614C31.9332 20.7927 32.7839 22.152 32.5711 23.6971C32.3592 25.2425 31.1649 26.3887 29.9027 26.258Z",
    fill: "#E4B692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 23.6981C15.2653 22.153 16.1164 20.7936 17.3773 20.6623C18.6406 20.531 19.8362 21.6779 20.048 23.2233C20.2612 24.767 19.4081 26.127 18.1469 26.259C16.8843 26.3893 15.6901 25.2431 15.4785 23.6981Z",
    fill: "#F1C9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9627 22.332C30.9627 16.671 27.8454 13.4519 24 13.4519V32.5827C27.8451 32.5827 30.9627 29.6292 30.9627 22.332Z",
    fill: "#E4B692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2628 27.0768C29.8882 28.1298 29.2546 29.3957 28.1097 29.3957C26.6787 29.3957 25.6552 28.2326 24.0137 28.2326C24.009 28.2326 24.0047 28.2333 24.0001 28.2333C23.9951 28.2333 23.9908 28.2326 23.9858 28.2326C22.3446 28.2326 21.3214 29.3957 19.8898 29.3957C18.7449 29.3957 18.1116 28.1298 17.737 27.0768L17.4127 25.0483V27.4757C17.4127 27.4757 17.9568 30.3343 19.0009 31.025C19.8513 31.7806 22.6274 33.075 23.9852 33.075C23.9898 33.075 23.9948 33.0743 23.9997 33.0743C24.0044 33.0743 24.009 33.075 24.0133 33.075H24.014C25.372 33.075 28.1482 31.7809 28.9983 31.025C30.0423 30.3343 30.5864 27.4757 30.5864 27.4757V25.0483L30.2628 27.0768Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6282 14.5351C20.6282 14.5351 17.0745 19.7269 29.1266 22.4171C28.4489 21.2471 28.3259 19.8307 28.3259 19.8307C28.3259 19.8307 29.496 21.0624 31.4047 22.0478C32.4518 19.9543 33.6835 16.8135 30.9124 15.0894C28.1412 13.365 21.5519 10.2855 20.6282 14.5351Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2248 21.551C20.2248 21.551 18.567 17.075 20.9881 14.6892C19.089 13.8606 16.1948 16.3827 16.5025 17.9222C17.0953 20.8879 20.2248 21.551 20.2248 21.551Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4935 38.7718C34.5897 37.0617 30.8245 35.7245 27.8462 34.9072C27.7295 36.933 26.0551 38.5411 23.9998 38.5411C21.9448 38.5411 20.2701 36.933 20.1537 34.9072C17.1754 35.7245 13.4099 37.0617 12.5061 38.7718C11.3625 42.8361 10.406 48 10.406 48H23.9998H37.5936C37.5936 48 36.9474 42.4631 35.4935 38.7718Z",
    fill: "#D34646"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.9307 35.9019C20.054 37.9277 21.8255 39.5357 23.9995 39.5357C26.1739 39.5357 27.9451 37.9277 28.0684 35.9019C30.7981 36.6098 34.1491 37.7085 35.6186 39.1014C35.5775 38.99 35.5357 38.8799 35.4929 38.7718C34.5891 37.0617 30.8239 35.7245 27.8456 34.9072C27.7289 36.933 26.0545 38.5411 23.9992 38.5411C21.9442 38.5411 20.2695 36.933 20.1532 34.9072C17.1748 35.7245 13.4093 37.0617 12.5055 38.7718C12.4786 38.8677 12.4518 38.9648 12.4249 39.0616C13.9169 37.688 17.2272 36.6028 19.9307 35.9019Z",
    fill: "#E53D0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.021 35.2335C19.3983 37.6472 21.4805 39.496 24 39.496C26.5195 39.496 28.6016 37.6472 28.9789 35.2335C28.594 35.1168 28.214 35.008 27.8463 34.9072C27.7296 36.933 26.0553 38.5411 24 38.5411C21.945 38.5411 20.2703 36.933 20.1539 34.9072C19.7859 35.008 19.4059 35.1168 19.021 35.2335Z",
    fill: "#D42D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1328 30.0576C25.1328 30.0576 24.967 29.3196 23.9999 29.3196C23.1156 29.3196 22.8669 30.0576 22.8669 30.0576H25.1328Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ef5aa8f2db04bf2db71d1081bb4ee4c2.svg";
export { ForwardRef as ReactComponent };